<template>
  <a-form :form="form" @submit.prevent="onSubmit" layout="vertical">
    <a-form-item v-bind="errorsBind('non_field_errors')" />
    <a-row :gutter="16">
      <a-col :span="12">
        <a-form-item label="Nazwa" v-bind="errorsBind('name')" required>
          <a-input v-model="form.name" />
        </a-form-item>
      </a-col>
      <a-col :span="12">
        <a-form-item label="Link" v-bind="errorsBind('url')" required>
          <a-input v-model="form.url" />
        </a-form-item>
      </a-col>
    </a-row>
    <a-row :gutter="16">
      <a-col :span="12">
        <a-form-item label="Login" v-bind="errorsBind('login')">
          <a-input v-model="form.login" />
        </a-form-item>
      </a-col>
      <a-col :span="12">
        <a-form-item label="Hasło" v-bind="errorsBind('password')">
          <a-input
            v-model="form.password"
            type="password"
            :placeholder="edited ? '••••••••' : ''"
          />
        </a-form-item>
      </a-col>
    </a-row>
    <a-alert class="banner" type="info" banner>
      <p v-if="!edited" slot="description">
        Nie przechowujemy na serwerze takich danych jak &nbsp;hasło.<br />
        Jeżeli uzupełnisz pole login oraz hasło, e-mail z&nbsp;tymi danymi
        zostanie wysłany do kursanta na przypisany do jego konta adres e-mail.
      </p>
      <p v-else slot="description">
        Nie przechowujemy hasła na serwerze. Hasło oraz login zostały wysłane
        podczas dodawania aplikacji na Twój adres e-mail.
      </p>
    </a-alert>
  </a-form>
</template>

<script>
import FieldHelper from '@/components/common/forms/FieldsHelper'

export default {
  extends: FieldHelper,
  props: {
    edited: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.banner {
  margin-bottom: 8px;
}
</style>
